
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/philosophy",
      function () {
        return require("private-next-pages/philosophy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/philosophy"])
      });
    }
  